export const actions = {
  LOAD_PROFILE_TOURS_REQUEST: 'profileTours/LOAD_PROFILE_TOURS_REQUEST',
  LOAD_PROFILE_TOURS_RESULT: 'profileTours/LOAD_PROFILE_TOURS_RESULT',
}

export function loadProfileTours(payload) {
  return {
    type: actions.LOAD_PROFILE_TOURS_REQUEST,
    payload,
  }
}
